/** Created by azhou on 2019/3/14.*/
<template>
  <div>
    <public-title>{{brand ? '线路行程管理' : '民宿活动列表'}}
      <div slot="right" class="ml-auto">
        <el-button size="small" type="success" @click="RouteTo()">添加{{brand ? '线路行程' : '活动'}}</el-button>
        <span class="text-link ml-4 h6" v-show="isGroup" @click="$router.back()">返回列表</span>
      </div>
    </public-title>
    <div class="load-area">
      <el-tabs v-if="brand" class="topTab" v-model="activeName" @tab-click="status= activeName == 'all' ? '' : activeName;getStoreDiscountLists({status})">
        <el-tab-pane :name="item.id" v-for="item in mealArr" :key="item.id" :label="item.name" />
      </el-tabs>
      <p v-if="StoreDiscountLists.total<=0" class="mt-5">当前没有数据</p>
      <div v-else class="p-4">
        <ul class="list-head"><li class="w-50" v-for="item in titleArr" :key="item">{{item}}</li></ul>
        <ul class="list-item" v-for="Itemize in StoreDiscountLists.lists" :key="Itemize.id">
          <li class="w-50 list-item-col">{{Itemize.title || Itemize.name}}</li>
          <li class="w-50 list-item-col flex-column" >
            <label>
              已添加 {{brand ? Itemize.itineraryDetailsArr.length : Itemize.count_price_nums}} 个
            </label>
            <span v-if="!brand" class="text-success mt-1 mb-1">已发布 {{Itemize.total_status_1}} 个</span>
            <span v-if="!brand" class="text-danger">待审核 {{Itemize.count_price_nums - Itemize.total_status_1}} 个</span>
          </li>
          <li class="w-50 list-item-col">{{(Itemize.create_time || Itemize.time) | formatTimestamp(1)}}</li>
          <li v-if="brand" class="w-50 list-item-col">已上传{{Itemize.pic.split(',').length}}张图片</li>
          <li class="w-50 list-item-col" :class="Itemize.status ? 'text-success' : 'text-danger'">
            <div v-if="brand">
              <span :class="Itemize.status == 1 ? 'text-success' : 'text-danger'">{{Itemize.status? '启用中' : '已下架'}}</span>
              <span class="text-link" @click="changeStatus(Itemize)">（{{Itemize.status ? '下架' : '上架'}}）</span>
            </div>
            <div v-else>{{Itemize.status? '已发布' : '审核中'}}</div>
          </li>
          <li class="w-50 list-item-col-end">
            <span class="text-link mr-2" @click="RouteTo(Itemize)">{{brand ? '查看' : '编辑'}}</span>
            <span class="text-link" @click="deleteDiscount(Itemize)">删除</span>
          </li>
        </ul>
        <el-pagination background layout="prev, pager, next" class="mt-4"
                      :total="StoreDiscountLists.total" :current-page="currentPage"
                      @current-change="v => getStoreDiscountLists({page:v,status})"/>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions,mapState,mapMutations } from 'vuex'

  export default {
    name: 'StoreActivityLists',
    computed: {
      ...mapState(['StoreDiscountLists']),
      ...mapGetters(['storeInfo','isGroup','brand']),
      queryCon() { return this.$route.query },
      titleArr () {
        let arr = ['活动名称','活动种类','添加时间','状态','操作'];
        if (this.brand) arr = ['线路行程名称','活动类型','添加时间','活动相册','状态','操作']
        return arr
      }
    },
    data() {
      return {
        currentPage:1,
        status: '',
        activeName:'all',
        mealArr: [{id:'all',name:'全部'},{id:'1',name:'已上架'},{id:'0',name:'已下架'}],
      }
    },
    mounted() {
      this.UPDATECURRENTSTORE({storeId:this.queryCon.store})
      this.getStoreDiscountLists({...this.queryCon,page:this.currentPage,status});
    },
    beforeDestroy() {
      this.UPDATECURRENTSTORE({storeId:''})
    },
    methods:{
      ...mapMutations(['UPDATECURRENTSTORE']),
      ...mapActions(['getStoreDiscountLists','deleteStoreDiscount','addEditDiscount']),
      changeStatus (item) {
        this._confirm(`确定将该线路行程${item.status ? '下架' : '上架'}么？`,() => {
          this.addEditDiscount({
              type: 'edit',
              data: {
                ...item,
                store_type: this.storeInfo.type,
                itinerary_id: item.id,
                status: item.status == 1 ? '0' : '1'
              },
              successFun: res => {
                this.getStoreDiscountLists({status})
                this.activeName = 'all'
              }
          })
        })
      },
      //添加、编辑活动
      RouteTo(item) {
        if (!this.$GFUN.powerIsInArray([313,314,597,598])) { this._alert('您没有相关权限！',null,'error'); return; }
        let query = {store:this.$route.query.store};
        if (item) query.discount = item.id;
        if (this.brand) {
          if (item) this.$router.push({name:'RouteChildList',query})
          else this.$router.push({name:'addEditActivity',query})
        } else this.$router.push({name:'addEditActivity',query})
      },
      //删除活动
      deleteDiscount(item) {
        if (!this.$GFUN.powerIsInArray([315,599])) { this._alert('您没有相关权限！',null,'error'); return; }
        this._confirm('确认删除么？',() => { this.deleteStoreDiscount(item.id) });
      },
    },
  }
</script>
